import Http from '@/utils/http'

const VEHICLE_ENDPOINT = '/vehicles/'

export const postVehicle = (data) => Http.post(VEHICLE_ENDPOINT, data)
export const getVehicle = (id) => {
  return Http.get(`${VEHICLE_ENDPOINT + id}/`)
}
export const getVehicles = () => Http.get(VEHICLE_ENDPOINT)
export const deleteVehicle = (id) => {
  return Http.delete(`${VEHICLE_ENDPOINT + id}/`)
}
export const putVehicle = (data) => {
  return Http.put(`${VEHICLE_ENDPOINT + data.id}/`, data)
}



// WEBPACK FOOTER //
// ./src/services/vehicle.js